import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Pagination } from 'src/app/core/pagination/pagination';
import { ReviewMissedDataService } from '../review-missed-data.service';
import { SortingService } from 'src/app/core/services/sorting.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { NotifierService } from 'angular-notifier';
import { StatusHandlerService } from 'src/app/core/services/status-handler.service';
import { HeaderService } from 'src/app/core/header/header.service';
import { DatePipe } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-review-missed-data-list',
  templateUrl: './review-missed-data-list.component.html',
  styleUrls: ['./review-missed-data-list.component.scss'],
  providers: [DatePipe]
})
export class ReviewMissedDataListComponent implements OnInit {


  @ViewChild('clientMaster')
  public clientMaster!: NgSelectComponent;

  public totalPages: number | any;
  public currentPage: number | any;
  public pagination: Pagination | any;
  public showLoader: boolean = false;
  public errorMessage: any = null;
  public rlSearchList: any = [];
  public urlInstancesAndSchedulesSearchList1: any = [];
  public urlInstancesAndSchedulesSearchList2: any = [];

  public MissedActionDataSearchList1: any = [];
  public MissedActionDataSearchList2: any = [];
  public MissedActionDataSearchList3: any = [];
  public MissedActionDataSearchList4: any = [];
  public MissedActionDataSearchList5: any = [];
  public MissedActionDataSearchList6: any = [];
  public MissedActionDataSearchList7: any = [];
  private readonly notifier: NotifierService;
  bsModalRef!: BsModalRef;
  public clientMasterOptionsList: any = [];
  public colSpan: number = 25;
  public modalRef?: BsModalRef;
  public wrapText: boolean = false;
  public columnValueList: any = null;
  public clientMasterId: any = [];
  public ProcessDate: null | string | undefined | any = null;
  public totalRecordsForPagination: number = 0;
  public config: PerfectScrollbarConfigInterface = {};
  public disableSendCMSBtn: boolean = true;
  public disableRejectBtn: boolean = true;
  public isSearch: boolean = false;
  validationError: string | null = null;
  public filters = {
    crawledMasterDataID: '',
    urlDetailID: '',
    language: '',
    rlRecordStatus: '',
    lastUpdatedOn: '',
    pdfFileName: '',
    cmsID: '',
    rcmAPIRequest: '',
    rcmAPIResponse: '',
    returnXML: '',
    isCircuitBreaker: '',
    pdfConversionError: '',
    rcmAPIMessage: '',
    previousHTMLFileName: '',
    pdfFileUpdatedOn: '',
    translationErrorMessage: '',
    isTextTranslated: '',
    textTranslatedOn: '',
    fileOCRedOn: '',
    errorMessage: '',
    fileTranslatedToEnglishOn: '',
    vantageTransactionID: '',
    fileConvertedToHTMLOn: '',
    insuranceFormFileComparedOn: '',
    translatedPDFFileName: ''
  };
public filteredData: any = [];

  public columnDropdownFilter = [
    {
      id: 1, name: 'Is equal to', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 2, name: 'Is not equal to', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 3, name: 'Starts with', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 4, name: 'Contains', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 5, name: 'Does not contain', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 6, name: 'Ends with', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 7, name: 'Is null', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    },
    {
      id: 8, name: 'Is not null', activeURLDetailID: false, activeScheduleMasterId: false, activeScheduleName: false, activeScheduleStartDate: false, activeURLConfigurationMasterID: false, activeCrawlingDate: false, activeCrawlingStatus: false, activeCEServerName: false, activeCreatedOn: false
      , activeRetryAttempts: false, activeComment: false, activeLastUpdatedOn: false, activeMastersheetId: false, activePushToCMS: false, activeStatusName: false
    }
  ];

  constructor(private reviewMissedDataService: ReviewMissedDataService,
    private errorHandler: ErrorHandlerService,
    private sortingService: SortingService,
    private configService: ConfigService,
    private notifierService: NotifierService,
    private statusService: StatusHandlerService,
    private headerService: HeaderService, public modalService: BsModalService,
    private datePipe: DatePipe,
    private router: Router,
    private cd: ChangeDetectorRef) {
    this.notifier = notifierService;
  }

  GetClientMasterOptions() {
    this.showLoader = true;
    this.reviewMissedDataService.GetClientMasterOptions().subscribe({
      next: (data: any) => {
        this.clientMasterOptionsList = data.Data;
        if (this.clientMasterOptionsList.length > 0) {
          this.clientMasterId = this.clientMasterOptionsList[0].ClientMasterID;
        }

        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  NavigateToSourceUrl(ID: any, Url: any) {

    if (Url && !Url.includes('http')) {
      // Url = 'https:' + Url;
      this.router.navigate([]).then(result => { window.open('https:/' + Url, '_blank'); });
    }
    else {
      this.router.navigate([]).then(result => { window.open(Url, '_blank'); });
    }

  }

  // downloadXml(xmlData: any, fieldName:any) {
  //   const xmlContent = xmlData;
  //   if (xmlContent) {
  //     const blob = new Blob([xmlContent], { type: 'application/xml' });
  //     const url = URL.createObjectURL(blob);

  //     const a = document.createElement('a');
  //     a.href = url;
  //     // a.download = 'CrawledData.xml';
  //     a.download = fieldName+'.xml';
  //     a.style.display = 'none';
  //     document.body.appendChild(a);
  //     a.click();
  //     URL.revokeObjectURL(url);
  //   }
  // }

  downloadFile(data: any, fieldName: string) {
    const content = data;
    if (content) {
      let blob: Blob;
      let url: string;
      let mimeType: string;
      let fileExtension: string;
  
      // Function to check if the string is a valid JSON
      const isJsonString = (str: string) => {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      };
  
      // Function to check if the string is a valid XML
      const isXmlString = (str: string) => {
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(str, "application/xml");
        return !parsedDoc.querySelector("parsererror");
      };
  
      if (isJsonString(content)) {
        mimeType = 'application/json';
        fileExtension = 'json';
      } else if (isXmlString(content)) {
        mimeType = 'application/xml';
        fileExtension = 'xml';
      } else {
        console.error('Unsupported file type');
        return;
      }
  
      blob = new Blob([content], { type: mimeType });
      url = URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fieldName}.${fileExtension}`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  }

  ngOnInit(): void {
    this.pagination = new Pagination("ID", false, 1);
    this.pagination.pageLength = 50;
    this.GetClientMasterOptions();
    this.GetMissedActionData(this.pagination);
  }

  SortColumn(newColumn: string) {
    let pagination = this.sortingService.SortColumn(this.pagination.columnName, newColumn, this.pagination.ascending, 1, this.pagination.searchText);
    pagination.clientMasterId = this.pagination.clientMasterId
    pagination.URLConfigurationMasterID = this.pagination.URLConfigurationMasterID;
    pagination.masterSheetId = this.pagination.masterSheetId;
    pagination.ClientName = this.pagination.ClientName;
    pagination.regLakeStatusId = this.pagination.regLakeStatusId;
    pagination.PushToCMS = this.pagination.PushToCMS;
    pagination.IsSeleniumRequired = this.pagination.IsSeleniumRequired;
    pagination.CrawledMasterDataID = this.pagination.CrawledMasterDataID;
    pagination.UrlDetailID = this.pagination.UrlDetailID;
    pagination.CreatedOn = this.pagination.CreatedOn;
    pagination.CrawledJSONID = this.pagination.CrawledJSONID;
    pagination.ErrorMessage = this.pagination.ErrorMessage;
    pagination.SourceURLError = this.pagination.SourceURLError;
    pagination.FieldLevelError = this.pagination.FieldLevelError;
    pagination.TotalReceivedRecords = this.pagination.TotalReceivedRecords;
    pagination.ProcessedRecords = this.pagination.ProcessedRecords;
    pagination.ErrorRecords = this.pagination.ErrorRecords;
    pagination.BrowserType = this.pagination.BrowserType;
    pagination.sourceUrl = this.pagination.sourceUrl;
    pagination.CrawledData = this.pagination.CrawledData;
    pagination.searchString = this.pagination.searchString;
    pagination.searchText = this.pagination.searchText;
    pagination.isDeleted = this.pagination.isDeleted = false;
    pagination.pageLength = this.pagination.pageLength
    this.pagination = pagination;

    this.GetMissedActionData(this.pagination);
  }

  Search(filterForm: any) {
    this.errorMessage = null;
    if (filterForm.invalid||!this.pagination.masterSheetId && !this.pagination.URLConfigurationMasterID) {
      this.errorMessage = 'Please enter either MasterSheet ID or URLConfigurationMaster ID.';
      return;
    }
    this.SearchMissedActionData();
  }

  SearchMissedActionData() {
    this.pagination.pageIndex = 1;
    this.isSearch = true;
    this.pagination.ProcessDate = this.datePipe.transform(this.pagination.ProcessDate, 'MM/dd/YYYY');
    this.pagination.startDate = this.datePipe.transform(this.pagination.startDate, 'MM/dd/YYYY');
    this.pagination.endDate = this.datePipe.transform(this.pagination.endDate, 'MM/dd/YYYY');
    this.GetMissedActionData(this.pagination);
  }

  Reset() {
    this.isSearch = false;
    this.pagination.pageIndex = 1;
    this.pagination.pageLength = 50;
    this.pagination.searchText = "";
    this.pagination.URLConfigurationMasterID = null;
    this.pagination.masterSheetId = null;
    this.pagination.searchString = null;
    const tempClientID=this.clientMasterId;
    this.clientMasterId=null;
    this.pagination.clientMasterId=null;
    this.pagination.ProcessDate = null;
    this.pagination.startDate = null;
    this.pagination.endDate = null;
    this.pagination.documentURL = null

    this.GetMissedActionData(this.pagination);
    this.clientMasterId=tempClientID;
  }

  GetMissedActionDataByPageLength() {
    this.pagination.pageIndex = 1;
    this.GetMissedActionData(this.pagination);
  }

  GetMissedActionData(paginationdetail: any) {

    this.errorMessage = null;
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.clientMasterId;
    this.showLoader = true;
    this.reviewMissedDataService.GetMissedActionData(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        this.totalPages = data.Data.TotalPage;
        this.currentPage = data.Data.CurrentIndex;
        // this.urlInstancesAndSchedulesSearchList1 = data.Data.Data[0].UrlInstanceAndSchedules_Result1;
        // this.urlInstancesAndSchedulesSearchList2 = data.Data.Data[0].UrlInstanceAndSchedules_Result2;
        // MissedActionData_Result1
        this.MissedActionDataSearchList1 = data.Data.Data[0].MissedActionData_Result1;
        this.MissedActionDataSearchList2 = data.Data.Data[0].MissedActionData_Result2;
        this.MissedActionDataSearchList3 = data.Data.Data[0].MissedActionData_Result3;
        this.MissedActionDataSearchList4 = data.Data.Data[0].MissedActionData_Result4;
        this.MissedActionDataSearchList5 = data.Data.Data[0].MissedActionData_Result5;
        this.MissedActionDataSearchList6 = data.Data.Data[0].MissedActionData_Result6;
        // this.MissedActionDataSearchList7 = data.Data.Data[0].MissedActionData_Result7;
        this.totalRecordsForPagination = data.Data.TotalRecordsForPagination;
        this.applyFilters();
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status)
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  applyFilters() {
    this.filteredData = this.MissedActionDataSearchList5.filter((item: any) => {
      return (
        (this.filters.crawledMasterDataID === '' || (item.CrawledMasterDataID && item.CrawledMasterDataID.toString().includes(this.filters.crawledMasterDataID))) &&
        (this.filters.urlDetailID === '' || (item.UrlDetailID && item.UrlDetailID.toString().includes(this.filters.urlDetailID))) &&
        (this.filters.language === '' || (item.Language && item.Language.toLowerCase().includes(this.filters.language.toLowerCase()))) &&
        (this.filters.rlRecordStatus === '' || (item.RLRecordStatus && item.RLRecordStatus.toLowerCase().includes(this.filters.rlRecordStatus.toLowerCase()))) &&
        (this.filters.lastUpdatedOn === '' || (item.LastUpdatedOn && this.isDateMatch(item.LastUpdatedOn, this.filters.lastUpdatedOn))) &&
        (this.filters.pdfFileName === '' || (item.PDFFileName && item.PDFFileName.toLowerCase().includes(this.filters.pdfFileName.toLowerCase()))) &&
        (this.filters.cmsID === '' || (item.CMSID && item.CMSID.toString().includes(this.filters.cmsID))) &&
        (this.filters.rcmAPIRequest === '' || (item.RCMAPIRequest && item.RCMAPIRequest.toLowerCase().includes(this.filters.rcmAPIRequest.toLowerCase()))) &&
        (this.filters.rcmAPIResponse === '' || (item.RCMAPIResponse && item.RCMAPIResponse.toLowerCase().includes(this.filters.rcmAPIResponse.toLowerCase()))) &&
        (this.filters.returnXML === '' || (item.ReturnXML && item.ReturnXML.toLowerCase().includes(this.filters.returnXML.toLowerCase()))) &&
        (this.filters.isCircuitBreaker === '' || (item.IsCircuitBreaker && item.IsCircuitBreaker.toLowerCase().includes(this.filters.isCircuitBreaker.toLowerCase()))) &&
        (this.filters.pdfConversionError === '' || (item.PDFConversionError && item.PDFConversionError.toLowerCase().includes(this.filters.pdfConversionError.toLowerCase()))) &&
        (this.filters.rcmAPIMessage === '' || (item.RCMAPIMessage && item.RCMAPIMessage.toLowerCase().includes(this.filters.rcmAPIMessage.toLowerCase()))) &&
        (this.filters.previousHTMLFileName === '' || (item.PreviousHTMLFileName && item.PreviousHTMLFileName.toLowerCase().includes(this.filters.previousHTMLFileName.toLowerCase()))) &&
        (this.filters.pdfFileUpdatedOn === '' || (item.PDFFileUpdatedOn && this.isDateMatch(item.PDFFileUpdatedOn, this.filters.pdfFileUpdatedOn))) &&
        (this.filters.translationErrorMessage === '' || (item.TranslationErrorMessage && item.TranslationErrorMessage.toLowerCase().includes(this.filters.translationErrorMessage.toLowerCase()))) &&
        (this.filters.isTextTranslated === '' || (item.IsTextTranslated && item.IsTextTranslated.toLowerCase().includes(this.filters.isTextTranslated.toLowerCase()))) &&
        (this.filters.textTranslatedOn === '' || (item.TextTranslatedOn && this.isDateMatch(item.TextTranslatedOn, this.filters.textTranslatedOn))) &&
        (this.filters.fileOCRedOn === '' || (item.FileOCRedOn && this.isDateMatch(item.FileOCRedOn, this.filters.fileOCRedOn))) &&
        (this.filters.errorMessage === '' || (item.ErrorMessage && item.ErrorMessage.toLowerCase().includes(this.filters.errorMessage.toLowerCase()))) &&
        (this.filters.fileTranslatedToEnglishOn === '' || (item.FileTranslatedToEnglishOn && this.isDateMatch(item.FileTranslatedToEnglishOn, this.filters.fileTranslatedToEnglishOn))) &&
        (this.filters.vantageTransactionID === '' || (item.VantageTransactionID && item.VantageTransactionID.toLowerCase().includes(this.filters.vantageTransactionID.toLowerCase()))) &&
        (this.filters.fileConvertedToHTMLOn === '' || (item.FileConvertedToHTMLOn && this.isDateMatch(item.FileConvertedToHTMLOn, this.filters.fileConvertedToHTMLOn))) &&
        (this.filters.insuranceFormFileComparedOn === '' || (item.InsuranceFormFileComparedOn && this.isDateMatch(item.InsuranceFormFileComparedOn, this.filters.insuranceFormFileComparedOn))) &&
        (this.filters.translatedPDFFileName === '' || (item.TranslatedPDFFileName && item.TranslatedPDFFileName.toLowerCase().includes(this.filters.translatedPDFFileName.toLowerCase())))
      );
    });
  
    // Apply sorting after filtering
    this.sortData(this.pagination.columnName);
  }
  
  // sortData(column: string) {
  //   if (this.pagination.columnName === column) {
  //     this.pagination.ascending = !this.pagination.ascending;
  //   } else {
  //     this.pagination.columnName = column;
  //     this.pagination.ascending = true;
  //   }

  //   // Perform sorting in-memory
  //   this.filteredData.sort((a: any, b: any) => {
  //     let comparison = 0;
  //     let valA = a[column];
  //     let valB = b[column];

  //     if (valA instanceof Date) {
  //       valA = valA.toISOString();
  //     } else if (typeof valA === 'number') {
  //       valA = valA.toString();
  //     } else {
  //       valA = valA ? valA.toString().toUpperCase() : '';
  //     }

  //     if (valB instanceof Date) {
  //       valB = valB.toISOString();
  //     } else if (typeof valB === 'number') {
  //       valB = valB.toString();
  //     } else {
  //       valB = valB ? valB.toString().toUpperCase() : '';
  //     }

  //     if (valA > valB) {
  //       comparison = 1;
  //     } else if (valA < valB) {
  //       comparison = -1;
  //     }

  //     return this.pagination.ascending ? comparison : -comparison;
  //   });
  // }

  sortData(column: string) {
    if (this.pagination.columnName === column) {
      this.pagination.ascending = !this.pagination.ascending;
    } else {
      this.pagination.columnName = column;
      this.pagination.ascending = true;
    }
  
    // Perform sorting in-memory
    this.filteredData.sort((a: any, b: any) => {
      let comparison = 0;
      const valA = a[column] ?? '';
      const valB = b[column] ?? '';
  
      // Determine if the column is numeric or date
      if (!isNaN(valA) && !isNaN(valB)) {
        // Numeric comparison
        comparison = Number(valA) - Number(valB);
      } else if (!isNaN(new Date(valA).getTime()) && !isNaN(new Date(valB).getTime())) {
        // Date comparison
        comparison = new Date(valA).getTime() - new Date(valB).getTime();
      } else {
        // String comparison
        const strA = valA.toUpperCase();
        const strB = valB.toUpperCase();
        if (strA > strB) {
          comparison = 1;
        } else if (strA < strB) {
          comparison = -1;
        }
      }
  
      return this.pagination.ascending ? comparison : -comparison;
    });
  }

  isDateMatch(itemDate: Date | string, filterDate: string): boolean {
    if (!itemDate) return false;
    const itemDateString = this.formatDate(itemDate);
    return itemDateString.includes(filterDate);
  }
  
  formatDate(date: Date | string): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return [month, day, year].join('/');
  }

  copyToClipboard(url: string): void {
    if (url) {
      navigator.clipboard.writeText(url).then(() => {
        this.notifier.notify('info', 'Copied Successfully');
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }

  DownloadCrawledDataErrors() {
    this.showLoader = true;
    this.reviewMissedDataService.crawledDataErrorsDataToXLS().subscribe({
      next: (data: any) => {
        this.showLoader = false;
        if (window.navigator.msSaveOrOpenBlob) {
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: 'application/pdf' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {

            window.navigator.msSaveOrOpenBlob(blob, + "CrawledDataErrors" + '.xlsx');
          }
          else {
            var objectUrl = URL.createObjectURL(blob);

            window.open(objectUrl, "CrawledDataErrors" + '.xlsx');
          }
        }
        else {
          var timeStamp = new Date();
          var currentYear = timeStamp.getFullYear();
          var nextYear = currentYear + 1;
          var exportLink = document.createElement('a');
          exportLink.href = 'data:application/pdf;base64,' + encodeURI(data);
          exportLink.download = "CrawledDataErrors" + '.xlsx';
          document.body.appendChild(exportLink);
          exportLink.click();
        }
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("CrawledDataErrors", error.status);
      }
    });
  }
  
}
